<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'chargeSetup.validFrom' | translate }}</label>
    <input appInputDate formControlName="validFrom" [defaultDate]="false" [attr.min]="firstValidDateString" />
  </app-input-group>

  @if (usesDifferentiatedPrices) {
    <app-input-group>
      <label appLabel>{{ 'chargeSetup.loadLevelLow' | translate }}</label>
      <input appInputNumber formControlName="loadLevelLow" [decimals]="6" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'chargeSetup.loadLevelHigh' | translate }}</label>
      <input appInputNumber formControlName="loadLevelHigh" [decimals]="6" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'chargeSetup.loadLevelPeak' | translate }}</label>
      <input appInputNumber formControlName="loadLevelPeak" [decimals]="6" />
    </app-input-group>
  }
  @else {
    <app-input-group>
      <label appLabel>{{ 'chargeSetup.singlePrice' | translate }}</label>
      <input appInputNumber formControlName="loadLevelNone" [decimals]="6" />
    </app-input-group>
  }
</form>
